import { postRecordId, samePostId, toPublicPost } from "@/lib/filters"
import { lumi } from "@/lib/lumi"
import type { Post } from "@/types"

type PostsApi = {
  get?: (id: string) => Promise<Post>
  list: (options?: {
    filter?: Record<string, unknown>
    sort?: Record<string, 1 | -1>
    limit?: number
  }) => Promise<{ list?: Post[] }>
}

function withId(post: Post, id: string, viewerId?: string): Post {
  return toPublicPost({ ...post, _id: postRecordId(post) || id }, viewerId)
}

export async function fetchPostById(postId?: string) {
  const id = postRecordId(decodeURIComponent(postId || ""))
  if (!id) return null

  const postsApi = lumi.entities.posts as PostsApi

  try {
    if (typeof postsApi.get === "function") {
      const got = await postsApi.get(id)
      if (got && (!postRecordId(got) || samePostId(got, id))) {
        return withId(got, id)
      }
    }
  } catch (err) {
    console.error("Post get failed:", err)
  }

  try {
    const filtered = await postsApi.list({ filter: { _id: id }, limit: 1 })
    const hit = ((filtered?.list || []) as Post[]).find((item) => samePostId(item, id))
    if (hit) return withId(hit, id)
  } catch (err) {
    console.error("Post id filter failed:", err)
  }

  const res = await postsApi.list({ sort: { createdAt: -1 }, limit: 400 })
  const listed = ((res?.list || []) as Post[]).find((item) => samePostId(item, id))
  return listed ? withId(listed, id) : null
}
